import { inject, Injectable } from '@angular/core';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { MobileAppDialogComponent } from '@app/+onboarding/chapters/mobile-app/mobile-app-dialog.component';
import { OnboardingUtils } from '@app/+onboarding/onboarding.utils';
import { TrackingService } from '@app/services/tracking.service';
import { SbDialogService } from '@sb/ui/dialog';
import { ModalBundle } from '@shiftbase-com/ts-shared/models';
import { take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MobileAppOnboardingService {
  private dialogService = inject(SbDialogService);
  private onboardingUtils = inject(OnboardingUtils);
  private trackingService = inject(TrackingService);

  openDialog(originator = 'onboarding') {
    this.trackingService.event('Onboarding Download Mobile App Started', { originator });

    return this.dialogService
      .setSize('xxl')
      .open<MobileAppDialogComponent, ModalBundle, OnboardingDialogResult>(MobileAppDialogComponent, {
        data: { originator },
      })
      .closed.pipe(
        take(1),
        tap((result: OnboardingDialogResult) => {
          if (!result?.action) {
            this.onboardingUtils.stripOnboardingParamsFromRoute();
          }
        }),
      );
  }
}
